import {
  FiAward,
  FiBookOpen,
  FiCheckCircle,
  FiCoffee,
  FiLock,
  FiShield,
  FiTarget,
  FiTool,
  FiUsers,
  FiActivity,
} from "react-icons/fi";

/**
 * Training navbar dropdown — exact ACE structure:
 * flat course list + nested flyout under "ISO Lead Auditor Course".
 * Links map to MBA training routes.
 */
export const TRAINING_NAV_ITEMS = [
  { name: "IOSH Managing Safely", link: "/iosh-managing-safely-training" },
  {
    name: "ISO Lead Auditor Course",
    link: "/iso-lead-auditor-training",
    /*children: [
      {
        name: "Exemplar Global USA recognised Lead Auditor Courses",
        link: "/iso-lead-auditor-training",
      },
      {
        name: "CQI-IRCA Approved Lead Auditor Courses",
        link: "/iso-lead-auditor-training",
      },
    ],*/
  },
  //{ name: "ISO Lead Implementer Course", link: "/iso-lead-auditor-training" },
 // { name: "NEBOSH IGC Course", link: "/highfield-training" },
  { name: "Highfield (HABC) UK Course", link: "/highfield-training" },
 // { name: "Industrial Training", link: "/corporate-training" },
  { name: "Corporate Training", link: "/corporate-training" },
  { name: "Safety Training Courses", link: "/safety-training" },
  //{ name: "ISO Awareness Courses", link: "/iso-lead-auditor-training" },
  //{ name: "Internal Auditing Techniques", link: "/corporate-training" },
  { name: "Certificate Verification", link: "/Certifications" },
  //{ name: "OSHA Course", link: "/highfield-training" },
  { name: "HACCP Level 2 / 3 / 4", link: "/haccp-training" },
  { name: "PECB Training", link: "/pecb-training" },
];

/** @deprecated Use TRAINING_NAV_ITEMSTraining — kept for any legacy imports */
export const TRAINING_NAV_GROUPS = [
  {
    group: "Training Courses",
    items: TRAINING_NAV_ITEMS.map(({ name, link }) => ({ name, link })),
  },
];

/** Flat list for JSON-LD / legacy use */
export const TRAINING_NAV_LINKS = TRAINING_NAV_ITEMS.flatMap((item) =>
  item.children ? [item, ...item.children] : [item]
);

/**
 * ACE-style standards lists shown on category training pages
 * (not used on /iso-lead-auditor-training — that page stays unchanged).
 */
export const TRAINING_PAGE_STANDARDS = {
  foodSafety: {
    heading: "Food Safety & Agriculture Standards",
    intro:
      "We assist food manufacturers, processors, exporters, farms, and supply chain organizations in meeting global food safety and agricultural compliance requirements through training and implementation support.",
    benefits: [
      "Ensure food safety compliance",
      "Access international export markets",
      "Build consumer confidence",
    ],
    standards: [
      "ISO 22000 – Food Safety Management System",
      "HACCP – Hazard Analysis & Critical Control Points",
      "FSSC 22000 – Food Safety System Certification",
      "BRCGS (including BRC Packaging)",
      "IFS – International Featured Standards",
      "HALAL Certification",
      "GMP / GMP+",
      "GLOBAL GAP",
      "Kosher",
      "Highfield (HABC) Food Safety Qualifications",
    ],
  },
  highfield: {
    heading: "Highfield (HABC) UK Courses",
    intro:
      "Internationally recognized Highfield qualifications focused on health, safety, food safety, and professional compliance for individuals and corporate teams.",
    benefits: [
      "Globally recognized certificates",
      "Practical, competency-based learning",
      "Suitable for public and in-house delivery",
    ],
    standards: [
      "Food Safety Training (Levels for handlers to managers)",
      "Health & Safety / Fire Safety Awards",
      "COSHH & Workplace Risk Awareness",
      "ISO Awareness Programs",
      "Professional Skill Development",
    ],
  },
  informationSecurity: {
    heading: "Information Technology & Data Security Standards",
    intro:
      "Structured training for IT governance, data protection, and information security frameworks — helping teams protect sensitive information and strengthen cyber resilience.",
    benefits: [
      "Protect sensitive information",
      "Improve IT governance",
      "Enhance cyber security resilience",
    ],
    standards: [
      "ISO/IEC 27001 – Information Security Management",
      "ISO/IEC 27002 – Information Security Controls",
      "ISO/IEC 27701 – Privacy Information Management",
      "ISO/IEC 20000 – IT Service Management",
      "GDPR – General Data Protection Regulation",
      "PCI DSS – Payment Card Industry Data Security",
      "SOC 2 Type II",
      "HIPAA awareness & compliance training",
      "CMMI / VAPT awareness programs",
    ],
  },
  productCompliance: {
    heading: "Product, Sustainability & Compliance Standards",
    intro:
      "Corporate and industrial training supporting regulatory approvals, ethical certifications, sustainability benchmarks, and product conformity requirements.",
    benefits: [
      "Meet global regulatory requirements",
      "Strengthen brand reputation",
      "Demonstrate environmental & social responsibility",
      "Improve global market acceptance",
    ],
    groups: [
      {
        title: "Product & Regulatory Compliance",
        items: ["CE Mark", "FDA Compliance", "ECO STEP", "Product Conformity Support"],
      },
      {
        title: "Textile & Organic Certifications",
        items: ["GOTS", "OCS", "GRS", "RCS"],
      },
      {
        title: "Social & Ethical Compliance",
        items: ["BSCI", "SA 8000", "SEDEX", "SMETA"],
      },
      {
        title: "Sustainability & Environmental Reporting",
        items: ["Green Building / LEED", "GRI", "Carbon Footprint"],
      },
    ],
  },
};

/** ACE-style pathway list shown on the Training landing page */
export const TRAINING_CATEGORIES = [
  {
    id: "quality-env-food",
    title: "Quality, Environment & Food Safety Courses",
    description:
      "Programs covering quality management, environmental systems, and food safety competencies.",
    icon: FiShield,
    link: "/haccp-training",
  },
  {
    id: "accredited",
    title: "International Accredited Courses",
    description:
      "Internationally aligned qualifications through Highfield and partner awarding bodies.",
    icon: FiAward,
    link: "/highfield-training",
  },
  {
    id: "lead-implementer",
    title: "Lead Implementer Courses",
    description:
      "Build the capability to plan and implement management systems within your organization.",
    icon: FiTarget,
    link: "/iso-lead-auditor-training",
  },
  {
    id: "lead-auditor",
    title: "Lead Auditor Courses",
    description:
      "Plan, conduct, and report management system audits with internationally recognized methods.",
    icon: FiBookOpen,
    link: "/iso-lead-auditor-training",
  },
  {
    id: "internal-auditing",
    title: "Internal Auditing Techniques",
    description:
      "Practical techniques to run effective internal audits and strengthen process controls.",
    icon: FiCheckCircle,
    link: "/corporate-training",
  },
  {
    id: "corporate",
    title: "Corporate Training",
    description:
      "Customized in-house programs for workforce upskilling, compliance, and leadership.",
    icon: FiUsers,
    link: "/corporate-training",
  },
  {
    id: "industrial",
    title: "Industrial Training",
    description:
      "Hands-on industrial and operational training tailored to site and sector requirements.",
    icon: FiTool,
    link: "/corporate-training",
  },
  {
    id: "information-security",
    title: "Information Security Courses",
    description:
      "PECB-aligned pathways in information security, privacy, and cyber resilience.",
    icon: FiLock,
    link: "/pecb-training",
  },
  {
    id: "food-safety",
    title: "Food Safety Courses",
    description:
      "HACCP and Highfield food safety qualifications for handlers through management.",
    icon: FiCoffee,
    link: "/haccp-training",
  },
  {
    id: "health-safety",
    title: "Health & Safety Courses",
    description:
      "Workplace health and safety programs including fire safety, first aid, confined space, and related awards.",
    icon: FiShield,
    link: "/safety-training",
  },
  {
    id: "iosh",
    title: "IOSH Managing Safely",
    description:
      "Globally recognized health and safety leadership training for managers and supervisors.",
    icon: FiUsers,
    link: "/iosh-managing-safely-training",
  },
];

/** Explore Our Training Courses grid (ACE-aligned labels, existing routes) */
export const TRAINING_FEATURED_COURSES = [
  {
    id: "iso-lead-auditor",
    title: "ISO Lead Auditor Course",
    description:
      "This training prepares professionals to plan and conduct audits in line with ISO standards, identify nonconformities, and report findings with confidence.",
    category: "ISO Management Systems",
    link: "/iso-lead-auditor-training",
    cta: "View Programs",
    icon: FiAward,
  },
  {
    id: "iosh",
    title: "IOSH Managing Safely",
    description:
      "A practical health and safety program for managers and supervisors — building the skills to assess risk, investigate incidents, and lead safer teams.",
    category: "Health & Safety",
    link: "/iosh-managing-safely-training",
    cta: "View Course",
    icon: FiUsers,
  },
  {
    id: "highfield",
    title: "Highfield (HABC) UK Course",
    description:
      "Internationally recognized training focused on health, safety, and compliance, providing practical skills for workplace excellence.",
    category: "Food Safety & H&S",
    link: "/highfield-training",
    cta: "Explore Courses",
    icon: FiCoffee,
  },
  {
    id: "safety",
    title: "Safety Training Courses",
    description:
      "Practical workplace safety programs covering fire safety, first aid, confined space, permit to work, LOTO, work at height, and more.",
    category: "Health & Safety",
    link: "/safety-training",
    cta: "Browse Safety Courses",
    icon: FiActivity,
  },
  {
    id: "haccp",
    title: "HACCP Level 2 / 3 / 4",
    description:
      "Structured food safety training for operational staff, supervisors, and managers responsible for HACCP systems.",
    category: "Food Safety",
    link: "/haccp-training",
    cta: "Learn More",
    icon: FiShield,
  },
  {
    id: "pecb",
    title: "PECB Certification Training",
    description:
      "Professional certification pathways in information security, privacy, and business continuity management.",
    category: "Information Security",
    link: "/pecb-training",
    cta: "View PECB Courses",
    icon: FiLock,
  },
  {
    id: "iso-lead-implementer",
    title: "ISO Lead Implementer Course",
    description:
      "Focuses on implementing ISO standards within an organization, including developing documentation, controls, and continual improvement practices.",
    category: "ISO Management Systems",
    link: "/iso-lead-auditor-training",
    cta: "Learn More",
    icon: FiTarget,
  },
  {
    id: "corporate",
    title: "Corporate Training",
    description:
      "Enhances employees’ professional and soft skills such as communication, leadership, and compliance culture.",
    category: "Corporate Programs",
    link: "/corporate-training",
    cta: "Request Training",
    icon: FiUsers,
  },
  {
    id: "industrial",
    title: "Industrial Training",
    description:
      "Hands-on experience aligned to real-world industrial environments, helping teams apply compliance practices on site.",
    category: "Corporate Programs",
    link: "/corporate-training",
    cta: "Request Training",
    icon: FiTool,
  },
  {
    id: "iso-awareness",
    title: "ISO Awareness Courses",
    description:
      "Introduces employees to the basics of ISO standards, promoting compliance awareness across the organization.",
    category: "ISO Management Systems",
    link: "/iso-lead-auditor-training",
    cta: "Browse Courses",
    icon: FiBookOpen,
  },
  {
    id: "internal-auditing",
    title: "Internal Auditing Techniques",
    description:
      "Teaches how to effectively conduct internal audits, review processes, and support certification readiness.",
    category: "Corporate Programs",
    link: "/corporate-training",
    cta: "Learn More",
    icon: FiCheckCircle,
  },
];

/** Options for the Training inquiry form select */
export const TRAINING_INQUIRY_OPTIONS = TRAINING_FEATURED_COURSES.map(
  (course) => course.title
);

const trainingImage = `${process.env.PUBLIC_URL}/assets/training.webp`;

/** Scheduled public programs with registration dates (existing MBA data) */
export const TRAINING_SCHEDULED_PROGRAMS = [
  {
    id: "habc-fire-l2-a",
    title: "HABC Level 2 Award in Fire Safety",
    image: trainingImage,
    category: "Health & Safety",
    link: "/highfield-training",
    dates: [
      { range: "Aug 15 - Aug 15, 2026" },
      { range: "Sep 12 - Sep 12, 2026" },
      { range: "Oct 10 - Oct 10, 2026" },
    ],
  },
  {
    id: "habc-fire-l1",
    title: "HABC Level 1 International Award in Fire Safety",
    image: trainingImage,
    category: "Health & Safety",
    link: "/highfield-training",
    dates: [
      { range: "Aug 22 - Aug 22, 2026" },
      { range: "Sep 19 - Sep 19, 2026" },
    ],
  },
  {
    id: "habc-coshh",
    title:
      "HABC Level 2 Award in the Control of Substances Hazardous to Health",
    image: trainingImage,
    category: "Health & Safety",
    link: "/highfield-training",
    dates: [{ range: "Sep 5 - Sep 5, 2026" }],
  },
];

export const TRAINING_INTRO = {
  badge: "Skills Development Programs",
  title: "Professional Training Programs for Compliance & Capability",
  brandLine: "MBA Solutions",
  subtitle:
    "MBA Solutions delivers practical, internationally aligned training programs designed to build audit-ready teams, strengthen compliance, and drive measurable performance across your organization.",
  paragraphs: [
    "MBA Solutions delivers a series of powerful skills development programs essential to driving results in management systems and strategic initiatives. Our courses are available via a public training schedule or, for larger groups, in-house at your facility. We also develop customized sessions based on your unique needs.",
    "Our team of corporate trainers delivers interactive programs that include class presentations, mock audits, assignments, role play, and examinations — available through physical, online, and blended learning formats.",
  ],
  deliveryModes: [
    "Public Training Schedule",
    "In-House Corporate Sessions",
    "Online & Blended Learning",
    "Customized Industry Programs",
  ],
  relatedServices: [
    { label: "Consulting", link: "/services" },
    { label: "Certification Support", link: "/Certifications" },
    { label: "Contact Us", link: "/contact" },
  ],
};

/** Landing-page FAQs for UX + FAQPage schema */
export const TRAINING_FAQS = [
  {
    q: "What training courses does MBA Solutions offer?",
    a: "We offer ISO Lead Auditor and Awareness courses, Highfield (HABC) qualifications, HACCP, PECB programs, IOSH Managing Safely, workplace safety training, and customized corporate or industrial programs.",
  },
  {
    q: "Do you offer public and in-house training?",
    a: "Yes. You can join scheduled public sessions or arrange in-house training at your facility. Online and blended options are also available for distributed teams.",
  },
  {
    q: "Are certificates internationally recognized?",
    a: "Many programs lead to internationally recognized awards through bodies such as Highfield, IOSH, and PECB, depending on the course you select. Course pages list the awarding body and certification details.",
  },
  {
    q: "Can training be customized for our industry?",
    a: "Absolutely. We adapt content, examples, and delivery to your sector, risk profile, and compliance goals so learning transfers directly to the workplace.",
  },
  {
    q: "How do I enquire or register for a course?",
    a: "Use the Contact for Training Courses form on this page, register from an upcoming program date, or reach out via our Contact page. Our team will confirm schedules, fees, and group options.",
  },
];
